import {SequenceComponent} from "../components";
import {v4 as uuid} from "uuid";

export class SequenceComponentHelper {

    static getDataIds(nodeData) {
        let voiceAnswerMap = new Map();
        let defaultVoiceAnswerId = null;
        let voiceAnswerTimeLimitId = null;
        let textAnswerMap = new Map();
        let textAnswerTimeLimitId = null;
        let videoId = null;
        let videoWithOutputId = null;
        let textQuestionId = null;
        let imageId = null;
        let textSlideId = null;
        let audioId = null;
        let infoMap = new Map();
        Object.keys(nodeData).forEach(key => {
            let dataKey = key.split('_');
            switch (dataKey[1]) {
                case SequenceComponent.VIDEO_CHILD_COMPONENT_KEY:
                    videoId = dataKey[0];
                    break;
                case SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY:
                    videoWithOutputId = dataKey[0];
                    break;
                case SequenceComponent.TEXT_QUESTION_CHILD_COMPONENT_KEY:
                    textQuestionId = dataKey[0];
                    break;
                case SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY:
                    voiceAnswerMap.set(dataKey[0], "value does not matter. we need only keys of a map  (which are distinct).");
                    break;
                case SequenceComponent.DEFAULT_VOICE_ANSWER_CHILD_COMPONENT_KEY:
                    if (defaultVoiceAnswerId !== null && defaultVoiceAnswerId !== dataKey[0]) {
                        throw new Error("Node should have ony one 'Default Voice Answer'. It looks like that it has two or more...");
                    }
                    defaultVoiceAnswerId = dataKey[0];
                    break;
                case SequenceComponent.VOICE_ANSWER_TIME_LIMIT_COMPONENT_KEY:
                    if (voiceAnswerTimeLimitId !== null && voiceAnswerTimeLimitId !== dataKey[0]) {
                        throw new Error("Node should have ony one 'Voice Answer Time Limit Component' if 'Voice Answer Component' is present. It looks like that it has two or more...");
                    }
                    voiceAnswerTimeLimitId = dataKey[0];
                    break;
                case SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY:
                    textAnswerMap.set(dataKey[0], "value does not matter. we need only keys of a map  (which are distinct).");
                    break;
                case "DefaultTextAnswerComponent":
                    // TODO: this case can be safety removed in APP ver 2.0
                    // it's temp solution to handle default text answers in older trainings
                    delete nodeData[key];
                    break;
                case SequenceComponent.TEXT_ANSWER_TIME_LIMIT_COMPONENT_KEY:
                    if (textAnswerTimeLimitId !== null && textAnswerTimeLimitId !== dataKey[0]) {
                        throw new Error("Node should have ony one 'Text Answer Time Limit Component' if 'Text Answer Component' is present. It looks like that it has two or more...");
                    }
                    textAnswerTimeLimitId = dataKey[0];
                    break;
                case SequenceComponent.IMAGE_CHILD_COMPONENT_KEY:
                    imageId = dataKey[0];
                    break;
                case SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY:
                    textSlideId = dataKey[0];
                    break;
                case SequenceComponent.AUDIO_CHILD_COMPONENT_KEY:
                    audioId = dataKey[0];
                    break;
                case SequenceComponent.INFO_CHILD_COMPONENT_KEY:
                    infoMap.set(dataKey[0], "value does not matter. we need only keys of a map  (which are distinct).");
                    break;
                default:
                    console.error(`unsupported component type`);
                    break;
            }
        });

        return {
            videoId: videoId,
            videoWithOutputId: videoWithOutputId,
            textQuestionId: textQuestionId,
            voiceAnswerIds: Array.from(voiceAnswerMap.keys()),
            defaultVoiceAnswerId: defaultVoiceAnswerId,
            voiceAnswerTimeLimitId: voiceAnswerTimeLimitId,
            textAnswerIds: Array.from(textAnswerMap.keys()),
            textAnswerTimeLimitId: textAnswerTimeLimitId,
            imageId: imageId,
            textSlideId: textSlideId,
            audioId: audioId,
            infoIds: Array.from(infoMap.keys()),
        };
    }

    static cloneData(nodeData) {
        const clonedData = {};

        // get data uuid's
        let dataUUIDs = [];
        Object.keys(nodeData).forEach(key => {
            let dataKey = key.split('_');
            dataUUIDs.push(dataKey[0]);
        });

        // get nested components uuid (distinct data uuid's)
        let nestedNodeUUIDs = Array.from(new Set(dataUUIDs));

        nestedNodeUUIDs.forEach(nestedNodeUUID => {
            let newKeyUUID = uuid();

            // loop through all cloned components and change its uuid
            Object.keys(nodeData).forEach(key => {
                let dataKey = key.split('_');
                if (dataKey[0] === nestedNodeUUID) {
                    let newKey = `${newKeyUUID}_${dataKey[1]}_${dataKey[2]}`;
                    clonedData[newKey] = nodeData[key];
                }
            });
        });

        return clonedData;
    }

    static generateTextAnswerOrder(node) {
        return this.generateOrder(node, SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY, SequenceComponent.TEXT_ANSWER_ORDER_KEY);
    }

    static generateInfoOrder(node) {
        return this.generateOrder(node, SequenceComponent.INFO_CHILD_COMPONENT_KEY, SequenceComponent.INFO_ORDER_KEY);
    }

    static normalizeTextAnswersOrder(nodeData) {
        this.normalizeOrder(nodeData, SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY, SequenceComponent.TEXT_ANSWER_ORDER_KEY);
    }

    static normalizeInfosOrder(nodeData) {
        this.normalizeOrder(nodeData, SequenceComponent.INFO_CHILD_COMPONENT_KEY, SequenceComponent.INFO_ORDER_KEY);
    }

    static generateOrder(node, componentKey, orderKey) {
        let currentHighestOrder = 0;

        Object.keys(node.data).forEach(key => {
            let dataKey = key.split('_');
            if (dataKey[1] === componentKey && dataKey[2] === orderKey && node.data[key] > currentHighestOrder) {
                currentHighestOrder = node.data[key];
            }
        });

        return currentHighestOrder + 1;
    }

    static normalizeOrder(nodeData, componentKey, orderKey) {
        let orderObjArray = [];
        Object.keys(nodeData).forEach(key => {
            let dataKey = key.split('_');
            if (dataKey[1] === componentKey && dataKey[2] === orderKey) {
                orderObjArray.push({
                    key: key,
                    order: nodeData[key]
                });
            }
        });
        orderObjArray.sort((a, b) => a.order - b.order);
        orderObjArray.forEach((orderObj, index) => {
            nodeData[orderObj.key] = index + 1;
        });
    }

    static hasAnswer(node) {
        return node.nestedComponents && (node.nestedComponents.textAnswer.isAdded || node.nestedComponents.voiceAnswer.isAdded);
    }

    static getVideoRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_REMOVE_BUTTON_KEY}`;
    }

    static getVideoFileKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_FILE_KEY}`;
    }

    static getVideoMappingKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_MAPPING_KEY}`;
    }

    static getVideoStereoModeKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.STEREO_MODE_KEY}`;
    }

    static getVideoStartFrameKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.START_FRAME_KEY}`;
    }

    static getVideoStopFrameKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.STOP_FRAME_KEY}`;
    }

    static getVideoOutputKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_OUTPUT_KEY}`;
    }

    static getVideoWithOutputRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_REMOVE_BUTTON_KEY}`;
    }

    static getVideoWithOutputFileKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_FILE_KEY}`;
    }

    static getVideoWithOutputMappingKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_MAPPING_KEY}`;
    }

    static getVideoWithOutputStereoModeKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_STEREO_MODE_KEY}`;
    }

    static getVideoWithOutputStartFrameKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_START_FRAME_KEY}`;
    }

    static getVideoWithOutputStopFrameKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_STOP_FRAME_KEY}`;
    }

    static getVideoWithOutputOutputKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VIDEO_WITH_OUTPUT_CHILD_COMPONENT_KEY}_${SequenceComponent.VIDEO_WITH_OUTPUT_OUTPUT_KEY}`;
    }

    static getTextQuestionRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_QUESTION_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_QUESTION_REMOVE_BUTTON_KEY}`;
    }

    static getTextQuestionQuestionKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_QUESTION_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_QUESTION_QUESTION_KEY}`;
    }

    static getVoiceAnswerRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.VOICE_ANSWER_REMOVE_BUTTON_KEY}`;
    }

    static getVoiceAnswerKeywordKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.VOICE_ANSWER_KEYWORDS_KEY}`;
    }

    static getVoiceAnswerScoreKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.VOICE_ANSWER_SCORE_KEY}`;
    }

    static getVoiceAnswerTimeLimitKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VOICE_ANSWER_TIME_LIMIT_COMPONENT_KEY}_${SequenceComponent.VOICE_ANSWER_TIME_LIMIT_KEY}`;
    }

    static getDefaultVoiceAnswerNodeSearchKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.DEFAULT_VOICE_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.DEFAULT_VOICE_ANSWER_NODE_SEARCH_KEY}`;
    }

    static getDefaultVoiceAnswerScoreKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.DEFAULT_VOICE_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.DEFAULT_VOICE_ANSWER_SCORE_KEY}`;
    }

    static getVoiceAnswerOutputKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.VOICE_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.VOICE_ANSWER_OUTPUT_KEY}`;
    }

    static getTextAnswerRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_ANSWER_REMOVE_BUTTON_KEY}`;
    }

    static getTextAnswerAnswerKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_ANSWER_ANSWER_KEY}`;
    }

    static getTextAnswerScoreKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_ANSWER_SCORE_KEY}`;
    }

    static getTextAnswerOrderKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_ANSWER_ORDER_KEY}`;
    }

    static getTextAnswerTimeLimitKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_ANSWER_TIME_LIMIT_COMPONENT_KEY}_${SequenceComponent.TEXT_ANSWER_TIME_LIMIT_KEY}`;
    }

    static getTextAnswerOutputKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_ANSWER_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_ANSWER_OUTPUT_KEY}`;
    }

    static getImageFileKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.IMAGE_CHILD_COMPONENT_KEY}_${SequenceComponent.IMAGE_FILE_KEY}`;
    }

    static getImageDurationKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.IMAGE_CHILD_COMPONENT_KEY}_${SequenceComponent.IMAGE_DURATION_KEY}`;
    }

    static getImageRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.IMAGE_CHILD_COMPONENT_KEY}_${SequenceComponent.IMAGE_REMOVE_BUTTON_KEY}`;
    }

    static getImageOutputKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.IMAGE_CHILD_COMPONENT_KEY}_${SequenceComponent.IMAGE_OUTPUT_KEY}`;
    }

    static getTextSlideHeaderKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_SLIDE_HEADER_KEY}`;
    }

    static getTextSlideTextKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_SLIDE_TEXT_KEY}`;
    }

    static getTextSlideDurationKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_SLIDE_DURATION_KEY}`;
    }

    static getTextSlideRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_SLIDE_REMOVE_BUTTON_KEY}`;
    }

    static getTextSlideOutputKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.TEXT_SLIDE_CHILD_COMPONENT_KEY}_${SequenceComponent.TEXT_SLIDE_OUTPUT_KEY}`;
    }

    static getAudioFileKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.AUDIO_CHILD_COMPONENT_KEY}_${SequenceComponent.AUDIO_FILE_KEY}`;
    }

    static getAudioRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.AUDIO_CHILD_COMPONENT_KEY}_${SequenceComponent.AUDIO_REMOVE_BUTTON_KEY}`;
    }

    static getInfoRemoveButtonKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.INFO_CHILD_COMPONENT_KEY}_${SequenceComponent.INFO_REMOVE_BUTTON_KEY}`;
    }

    static getInfoIconFileKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.INFO_CHILD_COMPONENT_KEY}_${SequenceComponent.INFO_ICON_FILE_KEY}`;
    }

    static getInfoTextKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.INFO_CHILD_COMPONENT_KEY}_${SequenceComponent.INFO_TEXT_KEY}`;
    }

    static getInfoOrderKey(nodeKey) {
        return `${nodeKey}_${SequenceComponent.INFO_CHILD_COMPONENT_KEY}_${SequenceComponent.INFO_ORDER_KEY}`;
    }
}